import { gsap } from 'gsap';

export default () => {
  var lastButtonScrollTop = 0;

  const getPercentOfView = function (elm) {
    var rect = elm.getBoundingClientRect();
    let spaceToScroll = window.innerHeight;
    return 1 - rect.bottom / spaceToScroll;
  };

  const checkAnimations = function (elm) {
    let descendants = elm.querySelectorAll('*');
    let hasAnimationsOver = true;
    for (let i = 0; i < descendants.length; i++) {
      if (descendants[i].classList.contains('has-transition')) {
        if (!descendants[i].classList.contains('transition-done')) {
          hasAnimationsOver = false;
        }
      }
    }
    return hasAnimationsOver;
  };

  const doTransition = function () {
    var parallaxElement = document.querySelectorAll('.parallax_scroll'),
      parallaxQuantity = parallaxElement.length;
    window.requestAnimationFrame(function () {
      for (var i = 0; i < parallaxElement.length; i++) {
        let el = parallaxElement[i];
        if (checkAnimations(el)) {
          let windowTop = window.scrollY,
            elementTop = el.getBoundingClientRect().top,
            elementHeight = el.offsetHeight,
            viewPortHeight = window.innerHeight - elementHeight;
          viewPortHeight = viewPortHeight > 160 ? 160 : viewPortHeight;
          viewPortHeight =
            viewPortHeight < 0 && viewPortHeight < -160 ? -160 : viewPortHeight;
          viewPortHeight = viewPortHeight * parseFloat(el.dataset.scroll);
          let toScroll = getPercentOfView(el);
          gsap.to(el, {
            duration: 1,
            ease: 'sine.out',
            overwrite: 'auto',
            x: 0,
            // y: scrolled * -(parseFloat(el.dataset.scroll)),
            y: window.innerWidth > 1000 ? viewPortHeight * toScroll : 0,
            z: 0,
          });
        }
      }
    });
  };

  // Scroll
  window.addEventListener('scroll', function () {
    doTransition();
  });

  window.addEventListener('load', function () {
    doTransition();
  });
};
